import { render, staticRenderFns } from "./createPaxelMarketJoinProcedure.vue?vue&type=template&id=0372ec0b&"
import script from "./createPaxelMarketJoinProcedure.vue?vue&type=script&lang=js&"
export * from "./createPaxelMarketJoinProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports